import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Box,
  useMediaQuery
} from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';
import bgImage3 from '../../../../assets/images/Home_Images/bg3.png'


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: '35vh',
  },
  sectionTwo: {
    fontFamily: 'Helvetica Neue',
    backgroundColor: fade('#fafafa', .2),

  },
  innerGridContainer: {
    
    paddingTop: '12vh',
    paddingBottom: '13vh',
  },
  innerGridHeading: {
    width: "100%",
    textAlign: "center",
    fontSize: '3rem',
    color: fade('#bdbdbd', 1),
    paddingLeft: 20,
    paddingRight: 20,
  },
  innerGridHeadingMobile: {
    width: "100%",
    textAlign: "center",
    fontSize: '2.5rem',
    color: fade('#bdbdbd', 1),
    paddingLeft: 20,
    paddingRight: 20,
    
  },
  sectionParagraph: {
    margin: "20px 0px",
    fontSize: '1rem',
    width: "100%",
    textAlign: "center",
    color: fade('#bdbdbd', 1),
  },
}));

export default function Home() {
  const classes = useStyles(); 
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <div className={classes.root} style={{ backgroundImage: `url(${bgImage3})` }}>
      <section className={classes.sectionTwo}>
        <Box className={classes.innerGridContainer} container spacing={2}>
          <h1 className={isMobile ? classes.innerGridHeading : classes.innerGridHeadingMobile} >
            "97% af verdens største brands mener at lyd kan styrke deres brand,
          </h1>
          <h1 className={isMobile ? classes.innerGridHeading : classes.innerGridHeadingMobile} >
            men kun 8% gør noget ved det… "
          </h1>
          <p className={classes.sectionParagraph}>Sounds Like Branding, Heartbeats International</p>
        </Box>
      </section>
    </div>
  )
}